<app-filter-drop-down [data]="companyService.companies()" [compareByField]="'id'" [formControl]="fc"
                      [label]="'Pick a company to use'" [formFieldClass]="'no-padding'" (selectionChange)="selectionChange($event)">
  <ng-template #template let-data>
    {{data.name}}
  </ng-template>
</app-filter-drop-down>
